import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import "./SelectCurrentCity.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import RedRoundBtn from "../../../Common_Btn/RedRoundBtn/RedRoundBtn";
import You_Are_Almost_There_Modal from "../../You_Are_Almost_There_Modal/You_Are_Almost_There_Modal";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { ContactUsForm, LoanForm } from "../../../../../utils/apis/form/form";
import Cookies from "js-cookie";
const SelectCurrentCity = ({
  alldata,
  smoke,
  qualification,
  income,
  occupation,
  city,
  setCity,
  ...props
}) => {
  const data = [
    {
      city: "Delhi",
      img: "/assets/Image/term_lifeinsuarnce/stepform/delhi.png",
    },

    {
      city: "Mumbai",
      img: "/assets/Image/term_lifeinsuarnce/stepform/mumbai.png",
    },

    {
      city: "Pune",
      img: "/assets/Image/term_lifeinsuarnce/stepform/pune.png",
    },

    {
      city: "Banglore",
      img: "/assets/Image/term_lifeinsuarnce/stepform/banglore.png",
    },
    {
      city: "Nagpur",
      img: "/assets/Image/term_lifeinsuarnce/stepform/delhi.png",
    },
  ];

  const statesWithCities = [
    {
      state: "Maharashtra",
      cities: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
    },
    {
      state: "Karnataka",
      cities: ["Bangalore", "Mysore", "Mangalore", "Hubli", "Belgaum"],
    },
    {
      state: "Gujarat",
      cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    },
    {
      state: "Rajasthan",
      cities: ["Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer"],
    },
    {
      state: "Uttar Pradesh",
      cities: ["Lucknow", "Kanpur", "Varanasi", "Agra", "Meerut"],
    },
    {
      state: "Tamil Nadu",
      cities: ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    },
    {
      state: "West Bengal",
      cities: ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"],
    },
    {
      state: "Punjab",
      cities: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala"],
    },
    {
      state: "Madhya Pradesh",
      cities: ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
    },
    {
      state: "Bihar",
      cities: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga"],
    },
    {
      state: "Gujarat",
      cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    },
    {
      state: "Rajasthan",
      cities: ["Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer"],
    },
    {
      state: "Uttar Pradesh",
      cities: ["Lucknow", "Kanpur", "Varanasi", "Agra", "Meerut"],
    },
    {
      state: "Tamil Nadu",
      cities: ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    },
    {
      state: "West Bengal",
      cities: ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"],
    },
    {
      state: "Punjab",
      cities: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala"],
    },
    {
      state: "Madhya Pradesh",
      cities: ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
    },
    {
      state: "Bihar",
      cities: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga"],
    },
  ];

  const [showCityList, setShowCityList] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const options = [
    { value: "delhi", label: "Delhi" },
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
    { value: "banglore", label: "Banglore" },
    { value: "nagpur", label: "Nagpur" },
    { value: "nashik", label: "Nashik" },
    { value: "aurangabad", label: "Aurangabad" },
    { value: "bangalore", label: "Bangalore" },
    { value: "mysore", label: "Mysore" },
    { value: "mangalore", label: "Mangalore" },
    { value: "hubli", label: "Hubli" },
    { value: "belgaum", label: "Belgaum" },
    { value: "ahmedabad", label: "Ahmedabad" },
    { value: "surat", label: "Surat" },
    { value: "vadodara", label: "Vadodara" },
    { value: "rajkot", label: "Rajkot" },
    { value: "gandhinagar", label: "Gandhinagar" },
    { value: "jaipur", label: "Jaipur" },
    { value: "udaipur", label: "Udaipur" },
    { value: "jodhpur", label: "Jodhpur" },
    { value: "kota", label: "Kota" },
    { value: "ajmer", label: "Ajmer" },
    { value: "lucknow", label: "Lucknow" },
    { value: "kanpur", label: "Kanpur" },
    { value: "varanasi", label: "Varanasi" },
    { value: "agra", label: "Agra" },
    { value: "meerut", label: "Meerut" },
    { value: "chennai", label: "Chennai" },
    { value: "coimbatore", label: "Coimbatore" },
    { value: "madurai", label: "Madurai" },
    { value: "tiruchirappalli", label: "Tiruchirappalli" },
    { value: "salem", label: "Salem" },
    { value: "kolkata", label: "Kolkata" },
    { value: "howrah", label: "Howrah" },
    { value: "durgapur", label: "Durgapur" },
    { value: "siliguri", label: "Siliguri" },
    { value: "asansol", label: "Asansol" },
    { value: "chandigarh", label: "Chandigarh" },
    { value: "ludhiana", label: "Ludhiana" },
    { value: "amritsar", label: "Amritsar" },
    { value: "jalandhar", label: "Jalandhar" },
    { value: "patiala", label: "Patiala" },
    { value: "bhopal", label: "Bhopal" },
    { value: "indore", label: "Indore" },
    { value: "jabalpur", label: "Jabalpur" },
    { value: "gwalior", label: "Gwalior" },
    { value: "ujjain", label: "Ujjain" },
    { value: "patna", label: "Patna" },
    { value: "gaya", label: "Gaya" },
    { value: "bhagalpur", label: "Bhagalpur" },
    { value: "muzaffarpur", label: "Muzaffarpur" },
    { value: "darbhanga", label: "Darbhanga" },
  ];

  const handleInputChange = async(cityName) => {
    // setSearchTerm(e.target.value);
    await setCity({ label: cityName, value: cityName }); 
    await onSubmit();
    // Update state as the user types
  };

  console.log(city, "city city");
  const handleCityChange = (selectedOption) => {
    setCity(selectedOption); // Set city to the value of selected city
  };

  const onSubmit = async (data) => {

    const formData = new FormData();

    formData.append("id", alldata?.id);

    formData.append("name", alldata?.name);
    formData.append("dob", alldata?.dob);
    formData.append("gender", alldata?.gender);
    formData.append("contact_no", alldata?.contact_no);
    formData.append("type", alldata?.type);
    formData.append("service", alldata?.service);
    formData.append("occupation", occupation);
    formData.append("qualification", qualification);
    formData.append("income", income);
    formData.append("smoke_status", smoke);
    formData.append("city", city?.value);

    const res = await LoanForm(formData);

    if (res?.success) {
      Cookies.set("user_data", JSON.stringify(res?.data), { expires: 7 });
      props.closeParentModal();
      setTimeout(() => {
        props?.setSuccessShowModalNew(true);
      }, 300);
    } else {
    }
  };
  useEffect(() => {
    if (city) {
      const selectedOption = options.find((option) => option.value === city);
      if (selectedOption) {
        setValue("city", selectedOption.value);
      }
    }
  }, [city, setValue]);

  const [searchTerm, setSearchTerm] = useState("");
  const filteredStates = statesWithCities
    .map((state) => ({
      ...state,
      cities: state.cities.filter((city) => city.toLowerCase().includes(searchTerm.toLowerCase())),
    }))
    .filter((state) => state.cities.length > 0); 
  return (
    <section className="SelectCurrentCity">
      {!showCityList ? (
        <>
          <p className="step_title">Select your current city</p>

          <div className="search_input_div blue_label_group">
            <InputGroup size="sm">
              <InputGroup.Text id="inputGroup-sizing-sm">
                <FontAwesomeIcon icon={faMagnifyingGlass} className="icon" />
              </InputGroup.Text>

              <Controller
              // defaultValue={city}
                name="city"
                
                control={control}
                rules={{ required: "Select City" }}
                render={({ field: { onChange, value, ref } }) => (
                  <Select
                  
                    value={city}
                    options={options}
                    placeholder="Enter Your City"
                    onChange={(selectedOption) => {
                      onChange(selectedOption); // Update react-hook-form's value
                      handleCityChange(selectedOption); // Set the city state
                    }}
                    isDisabled
                    // value={options.find((option) => option.value === value)}
                  />
                )}
              />
            </InputGroup>

            {errors.city && (
              <p className="text-danger">{errors.city.message}</p>
            )}
          </div>

          <div className="swiper_div">
            <Swiper
              className="country_slider"
              spaceBetween={15}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              modules={[Pagination]}
              autoplay={{ delay: 300 }}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                350: {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                420: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                486: {
                  slidesPerView: 3.5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                992: {
                  slidesPerView: 4.8,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 5.5,
                  spaceBetween: 10,
                },
                1400: {
                  slidesPerView: 6,
                  spaceBetween: 15,
                },
              }}
            >
              {data?.map((item) => {
                return (
                  <SwiperSlide
                    onClick={() =>
                      setCity({ label: item.city, value: item.city })
                    }
                  >
                    <div className="city_card_holder">
                      <div className="img_div">
                        <img src={item?.img} className="logo_img" />
                      </div>
                      <p className="city_name">{item?.city}</p>
                    </div>
                  </SwiperSlide>
                );
              })}

              <SwiperSlide>
                <div
                  className="city_card_holder"
                  onClick={() => {
                    setShowCityList(true);
                  }}
                >
                  <div className="img_div">
                    <img
                      src={
                        "/assets/Image/term_lifeinsuarnce/stepform/other.png"
                      }
                      className="logo_img"
                    />
                  </div>
                  <p className="city_name">{"Other"}</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </>
      ) : (
        <div className="city_list_main_card">
          <div className="card_header">
            <div className="state_main_div">
              <div className="icon_holder">
                <img
                  src="\assets\Image\term_lifeinsuarnce\stepform\building.png"
                  className="img"
                />
              </div>

              {/* <p className="dist_text">Satara</p> */}
              {/* <input
                type="text"
                className="dist_text_input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                // value={city.label}
                // onChange={handleInputChange} // Update the value when changed
                placeholder="Enter city"
              /> */}

              <Controller
                name="city"
                // className="dist_text_input"
                control={control}
                rules={{ required: "Select City" }}
                render={({ field: { onChange, value, ref } }) => (
                  <Select
                   className="dist_text_input"
                    // value={city }
                    options={options}
                    placeholder="Enter Your City"
                    onChange={(selectedOption) => {
                      onChange(selectedOption); // Update react-hook-form's value
                      handleCityChange(selectedOption); // Set the city state
                    }}
                    // value={options.find((option) => option.value === value)}
                  />
                )}
              />
            </div>
          </div>

          <div className="card_body">
        <div className="grid_view_outer">
          {filteredStates.map((item, index) => (
            <div key={index} className="grid_view_inner">
              <div className="state_div">
                <p className="state">{item.state}</p>
              </div>
              <div className="city_holder">
                {item.cities.map((cityName, i) => (
                  <p
                    key={i}
                    className="city_name"
                    onClick={() => handleInputChange(cityName)}
                  >
                    {cityName}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
          {/* <div className="card_body">
            <div className="grid_view_outer">
              {statesWithCities?.map((item) => {
                return (
                  <div className="grid_view_inner">
                    <div className="state_div">
                      <p className="state">{item?.state}</p>
                    </div>
                    <div className="city_holder">
                      {item?.cities?.map((city) => {
                        return (
                          <p
                            className="city_name"
                            onClick={() =>
                              setCity({ label: city, value: city })
                            }
                          >
                            {city}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div> */}
        </div>
      )}

      <div className="Continue_btn_holder">
        <RedRoundBtn
          btn_name="Continue"
          onClick={() => {
            onSubmit();
          }}
          // onClick={() => {
          //   props.closeParentModal();
          //   setTimeout(() => {
          //     props?.setSuccessShowModalNew(true);
          //   }, 300);
          // }}
        />
      </div>
    </section>
  );
};

export default SelectCurrentCity;
